export default __webpack_public_path__ + "986a9b0a8caf3b21a9419faa8fdc7c21a55c63ecb15c7a9ef14001a209b9154a.png";